// src/App.jsx (example)
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Projects from './Components/Research/Research';
import About from './Components/About/About';
import Home from "./Components/Home/Home";
import JunebaseSplash from "./Components/Splash/JunebaseSplash";
import Footer from "./Components/Footer/Footer";
import Contact from "./Components/Contact/ContactForm";


export default function App() {
  return (
    <div>
      <Navbar />
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
      </Routes>
      <Contact />
      <Footer />
    </div>
  );
}